// extracted by mini-css-extract-plugin
module.exports = {"container":"licence_container__DhYaK"};